import { render, staticRenderFns } from "./homeFxs.vue?vue&type=template&id=32383a1c&scoped=true&"
import script from "./homeFxs.vue?vue&type=script&lang=js&"
export * from "./homeFxs.vue?vue&type=script&lang=js&"
import style0 from "./homeFxs.vue?vue&type=style&index=0&id=32383a1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32383a1c",
  null
  
)

export default component.exports